import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReportTransactionIdStore} from '../../../../shared/store/report/report-transaction-id.store';

@Component({
  selector: 'app-transaction-id-report-details',
  templateUrl: './transaction-id-report-details.component.html',
  styleUrls: ['./transaction-id-report-details.component.scss']
})
export class TransactionIdReportDetailsComponent implements OnInit {
  @Input('row') public row: any;

  constructor(
    private readonly _reportTransactionIdStore: ReportTransactionIdStore
  ) { }

  ngOnInit(): void {}

  public getDeviceIcon(device: string): string {
    switch (device) {
      case 'desktop':
        return 'computer';
      case 'mobile':
        return 'smartphone';
      case 'offline':
        return 'store';
      case 'unknown':
        return 'device_unknown';
      case 'tablet':
        return 'tablet';
      case 'smart tv':
        return 'connected_tv';
    }
  }

  public onClose(): void {
    this._reportTransactionIdStore.details(null);
  }

}

